import _ from 'lodash'
import { call, put, takeEvery } from 'redux-saga/effects'
import { creators, types } from './redux'
import { SERVER_ERROR, TIMEOUT_ERROR } from 'apisauce'
import ErrorHandler from '../ErrorHandler'

function * request (action) {
  const callFunction = _.get(action, 'options.bypassInternalFlag') ? call : nvCall
  const clearFirst = _.get(action, 'options.clearFirst')
  if (clearFirst) {
    yield put(creators.clear(action.key))
  }
  const resp = yield callFunction(action.api, ...(action.args || []))
  if (_.get(resp, 'ok')) {
    yield put(creators.success(action.key, _.get(resp, 'data')))
  } else {
    const errorPath = _.get(action, 'options.errorPath', 'data.error')
    yield put(
      creators.failure(action.key, {
        problem: _.get(resp, 'problem'),
        ..._.get(resp, errorPath)
      })
    )
  }
}

function * nvCallSaga (api, ...args) {
  const resp = yield call(api, ...args)
  if (!_.get(resp, 'ok')) {
    const problem = _.get(resp, 'problem')
    if (problem === TIMEOUT_ERROR || problem === SERVER_ERROR) {
      yield put(ErrorHandler.creators.set({ data: _.get(resp, 'data') }))
    }
  }
  return resp
}

export function nvCall (api, ...args) {
  return call(nvCallSaga, api, ...args)
}

export default function * defaultSaga () {
  yield takeEvery(types.REQUEST, request)
}
